export const downloadModelAvailability = `query ModelDownload($filter: ModelDownloadRequest!) {
  modelDownload(filter: $filter) {
    name
    content
  }
}`;

export const getDashboardDownload = `query DashboardDownload($filter: DashboardDownloadRequest!) {
  dashboardDownload(filter: $filter) {
    name
    content
  }
}`;

export const downloadMaterialAvailability =`query DownloadMaterial($filter: DownloadMaterialRequest!) {
  DownloadMaterial(filter: $filter) {
    name
    content
  }
}`;

export const downloadServiceAvailability =`query DownloadServiceAvailability($filter: DownloadServiceAvailabilityRequest!) {
  DownloadServiceAvailability(filter: $filter) {
    name
    content
  }
}`;
export const downloadLocalizationDefault = `query DownloadLocalizationDefault($filter: DownloadDefaultRequest!) {
  downloadLocalizationDefault(filter: $filter) {
    name
    content
  }
}`;
export const downloadLocalizationAvailability = `query DownloadLocalization($filter: DownloadLocalizationRequest!) {
  downloadLocalizationAvailability(filter: $filter) {
    name
    content
  }
}`;
export const downloadTOFPM = `query TOFProgramsManagementDownload($filter: TOFProgramManagementDownloadRequest!) {
  tofProgramsManagementDownload(filter: $filter) {
    name
    content
  }
}`;
export const downloadParameterChoice = `query DownloadParameterLocalizationChoice($filter: DownloadParameterLocalizationChoiceRequest!) {
  downloadparameterLocalizationChoice(filter: $filter) {
    name
    content
  }
}`;
export const downloadParametersLOCMapping = `query DownloadParameterLocalization($filter: DownloadParametersLocalizationRequest!) {
  downloadParameterLocalization(filter: $filter) {
    name
    content
  }
}`; 